//import Moment from "moment";

const getCount = (state) => {
	return state.servicosPlano.length;
}

const ultimaAtualizacaoListaServicoPlano = (state) => {
	if (state.ultimaAtualizacaoListaservicoPlano == null) {
		return true;
	}
	else if(!state.servicosPlano)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.servicosPlano.length == 0 ||
			hour - state.ultimaAtualizacaoListaServicoPlano.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaServicoPlano
}